import { Input } from '@components/Input';
import { IconButton, InputAdornment } from '@mui/material';
import { ReactComponent as SearchIcon } from '@icons/search.svg';
import { ReactComponent as CrossIcon } from '@icons/cross.svg';
import { ChangeEvent, useState } from 'react';

export const SearchInput = ({ onSearch, placeholder = 'Search' }) => {
  const [localValue, setLocalValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value || '');
    setLocalValue(e.target.value || '');
  };
  const onClearInput = () => {
    onSearch('');
    setLocalValue('');
  };

  const onBlurInput = () => {
    setIsFocused(false);
  };

  const onFocusInput = () => {
    setIsFocused(true);
  };
  return (
    <Input
      variant="outlined"
      fullWidth
      placeholder={placeholder}
      value={localValue}
      onBlur={onBlurInput}
      onFocus={onFocusInput}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment:
          localValue && isFocused ? (
            <InputAdornment position="end">
              <IconButton sx={{ padding: 0 }} onMouseDown={onClearInput}>
                <CrossIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
};
